var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFj41(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m29.29,30H.71c-.25,0-.48-.13-.61-.34-.13-.21-.14-.47-.03-.7L14.36.36c.24-.48,1.04-.48,1.28,0l14.29,28.6c.11.22.1.49-.03.7-.13.21-.36.34-.61.34Zm-27.42-1.43h26.26L15,2.28,1.87,28.57Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m18.74,18.03c.15-.28.12-.63-.07-.88-.19-.25-.52-.37-.83-.31l-4.45.98,2.63-5.8c.19-.41,0-.9-.41-1.08-.41-.19-.9,0-1.08.41l-3.3,7.29c-.13.28-.09.61.11.85.19.24.51.35.81.28l4.3-.95-1.72,3.2-1.6-1.55s-.1-.05-.15-.03c-.05.02-.08.07-.08.13v4.42s.01.07.04.1.06.04.1.04h0l4.49-.07c.05,0,.1-.03.12-.09.02-.05,0-.11-.03-.15l-1.68-1.63s.04-.03.06-.06l2.74-5.11Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFj41);
export default __webpack_public_path__ + "static/media/FJ41.3ec47152749e0498211fa12fbcbd909f.svg";
export { ForwardRef as ReactComponent };